import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon, ArrowUpRightIcon } from 'lucide-react';
import { SectionHeader } from '../components/ui/SectionHeader';
import { ClosingInvitation } from '../components/sections/ClosingInvitation';
import { workspaces } from '../data/workspaces';
import { modules } from '../data/modules';
export function Workspaces() {
  return <>
      <section className="pb-12 pt-14 md:pt-20" data-id="element-742" data-mp="3mqpxkltxfogy">
        <div className="mx-auto max-w-7xl px-5 md:px-8" data-id="element-743" data-mp="3mpes8hku28nq">
          <SectionHeader as="h1" title="Seven fields. One connected environment." body="Each workspace is configured around the people who use it and the work they need to accomplish. Choose a field to see its interface, workflows, and modules." data-id="element-744" data-mp="3iocr1v7cvmj4" />
        </div>
      </section>

      <section className="pb-24 md:pb-32" data-id="element-745" data-mp="a9kz8nmyqw29">
        <div className="mx-auto max-w-7xl px-5 md:px-8" data-id="element-746" data-mp="5i2xhxd48rg8">
          <ul className="glass divide-y divide-ink/[0.07] overflow-hidden rounded-[28px]" data-id="element-747" data-mp="5gi3q9ymlcjf">
            {workspaces.map(w => {
            const Icon = w.icon;
            return <li key={w.slug} className="group relative grid gap-5 p-6 transition-colors duration-150 hover:bg-white/60 md:grid-cols-[minmax(0,1.1fr)_minmax(0,1.4fr)_auto] md:items-center md:gap-10 md:p-8" data-id="element-748" data-mp="26xmwifh7wfa1">
                  <div className="flex items-start gap-4" data-id="element-749" data-mp="1x7lk4ky88lay">
                    <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-white text-accent shadow-sm ring-1 ring-ink/[0.05]" data-id="element-750" data-mp="1j8u771v3p5oe">
                      <Icon className="h-5 w-5" aria-hidden="true" data-id="element-751" data-mp="1o6dmm53jbohx" />
                    </span>
                    <div data-id="element-752" data-mp="1aarzy4krxgso">
                      <h2 className="text-xl font-semibold tracking-tight" data-id="element-753" data-mp="1eaahcqddz9qr">
                        <Link to={`/workspaces/${w.slug}`} className="after:absolute after:inset-0 focus-visible:outline-none" data-id="element-754" data-mp="1ecdahj9u5izp">
                          {w.name}
                        </Link>
                      </h2>
                      <p className="mt-1 text-sm text-ink-muted" data-id="element-755" data-mp="lfuldzm1nnvo">{w.audience}</p>
                    </div>
                  </div>
                  <div data-id="element-756" data-mp="gghwl9bm46qg">
                    <p className="text-[15px] leading-relaxed text-ink-soft" data-id="element-757" data-mp="gf7yik4reyjt">{w.summary}</p>
                    <p className="mt-3 text-[13px] text-ink-muted" data-id="element-758" data-mp="cfz55gdmt2os">
                      <span className="font-medium text-ink" data-id="element-759" data-mp="7gmgcq379ljk">{w.surfaces.map(s => s.name).join(' · ')}</span>
                      <span className="mx-2 text-ink-faint" data-id="element-760" data-mp="146lt6wqdv67y">|</span>
                      {modules.filter(m => w.modules.includes(m.id)).map(m => m.name).join(', ')}
                    </p>
                  </div>
                  <div className="relative z-10 flex items-center gap-2" data-id="element-761" data-mp="qfqprzynlhbr">
                    <a href={w.demo.url} target="_blank" rel="noopener noreferrer" className="inline-flex h-9 items-center gap-1 whitespace-nowrap rounded-full px-3.5 text-sm font-medium text-ink-soft ring-1 ring-ink/10 transition-colors duration-150 hover:bg-white hover:text-ink" data-id="element-762" data-mp="1nucp4a59kxzj">
                      Demo <ArrowUpRightIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-763" data-mp="20cylqp8k05rp" />
                      <span className="sr-only" data-id="element-764" data-mp="20fbb3ngn5ies">for {w.name} (opens in a new tab)</span>
                    </a>
                    <span className="pointer-events-none inline-flex h-9 w-9 items-center justify-center rounded-full bg-accent text-white transition-transform duration-150 ease-out group-hover:translate-x-0.5" aria-hidden="true" data-id="element-765" data-mp="29dmzrjxy664l">
                      <ArrowRightIcon className="h-4 w-4" data-id="element-766" data-mp="2j36j0qpko1zz" />
                    </span>
                  </div>
                </li>;
          })}
          </ul>
        </div>
      </section>

      <ClosingInvitation title="Working across more than one field?" body="Many organizations combine workspaces on the same foundation. Tell us how your teams work and we’ll suggest a configuration." primary={{
      label: 'Discuss Your Workspace',
      to: '/contact'
    }} secondary={{
      label: 'How It Works',
      to: '/how-it-works'
    }} data-id="element-767" data-mp="2s4wc00z3r8zv" />
    </>;
}